import fileValidate from 'helpers/validates/file'

import toFileList from './toFileList'

// Contextos fora do FileUploadInput
const filterAccepted = (event, attachments, accept = '') => {
  const files = event.target.files
  const currentFiles = attachments ? Array.from(attachments) : []

  const newFiles =
    Array.from(files).filter(
      (newFile) =>
        !fileValidate.isFileInList(newFile, currentFiles) &&
        fileValidate.isFileAccepted(newFile, accept),
    ) || []

  return toFileList([...currentFiles, ...newFiles])
}

export default filterAccepted
